import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useFilesStore = defineStore("files", () => {
  const files = ref([]);
  const pagination = ref({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    limit: 50,
  });

  // 当前选中的文件列表
  const selectedFiles = computed(() =>
    files.value.filter((file) => file.isChecked)
  );

  // 选中文件数量
  const selectedCount = computed(() => selectedFiles.value.length);

  // 是否部分选中(有选中但未全选)
  const isPartiallySelected = computed(() => {
    const count = selectedCount.value;
    return count > 0 && count < files.value.length;
  });

  // 是否全部选中
  const isAllSelected = computed(
    () => selectedCount.value === files.value.length
  );

  // 是否为单选状态
  const isSingleSelected = computed(() => selectedCount.value === 1);

  /**
   * 设置文件列表
   * @param {Array} fileList - 文件列表数据
   */
  const setFiles = (data) => {
    files.value = data.files.map((file) => ({
      object_id: file.object_id,
      url: file.url,
      kodo_key: file.kodo_key,
      name: file.name,
      size: file.size,
      content_type: file.content_type,
      created_at: file.created_at,
      updated_at: file.updated_at,
      deleted_at: file.deleted_at,
      isChecked: false,
      in_recycle_bin: file.in_recycle_bin,
      is_banned: file.is_banned,
      // 开始转码：1 未开始转码：0
      been_transcoded: file.been_transcoded,
      is_hls: file.is_hls,
      is_source_file_deleted: file.is_source_file_deleted,
      // 转码完成：1 未完成或未转码：0
      is_transcoded: file.is_transcoded,
      transcoded_kodo_key: file.transcoded_kodo_key,
      is_cleared: file.is_cleared,
      cleared_at: file.cleared_at,
      isVideo: file.content_type?.startsWith("video/"),
      isImage: file.content_type?.startsWith("image/"),
      isAudio: file.content_type?.startsWith("audio/"),
      isDocument: /\.(doc|docx|xls|xlsx|ppt|pptx|pdf|txt)$/i.test(file.name),
    }));

    // 更新分页信息
    pagination.value = {
      currentPage: data.pagination.current_page,
      totalPages: data.pagination.total_pages,
      totalRecords: data.pagination.total_records,
      hasNextPage: data.pagination.has_next_page,
      hasPreviousPage: data.pagination.has_previous_page,
      limit: data.pagination.limit,
    };
  };

  return {
    files,
    pagination,
    setFiles,
    selectedFiles,
    selectedCount,
    isPartiallySelected,
    isAllSelected,
    isSingleSelected,
  };
});
